import {
  ApiBlueprint,
  AppRootElementBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { LlmChatApi, llmChatApiRef } from './api';
import { ChatDrawerStore, chatDrawerApiRef } from './drawerApi';
import { ChatDrawer } from './components/ChatDrawer';
import {
  catalogEntityRouteRef,
  scaffolderTaskRouteRef,
  scaffolderTemplateRouteRef,
} from './routes';

const llmChatApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: llmChatApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new LlmChatApi(discoveryApi, fetchApi),
    }),
});

const chatDrawerApi = ApiBlueprint.make({
  name: 'drawer',
  params: defineParams =>
    defineParams({
      api: chatDrawerApiRef,
      deps: {},
      factory: () => new ChatDrawerStore(),
    }),
});

// Mounted above the router, so the conversation and any stream in flight
// outlive navigation. The chat itself is lazy-loaded on first open.
const chatDrawer = AppRootElementBlueprint.make({
  name: 'drawer',
  params: { element: <ChatDrawer /> },
});

export const llmChatPlugin = createFrontendPlugin({
  pluginId: 'llm-chat',
  extensions: [llmChatApi, chatDrawerApi, chatDrawer],
  externalRoutes: {
    catalogEntity: catalogEntityRouteRef,
    scaffolderTemplate: scaffolderTemplateRouteRef,
    scaffolderTask: scaffolderTaskRouteRef,
  },
});
